/* eslint-disable camelcase */
import { useLocale } from '@/components/Link'
import { FragmentType, useFragment } from '@/generated/gql'
import { graphql } from '@/generated/gql/gql'
import { countries as localeCountries } from '@/helpers/countries'
import { getCurrencyCodeForCountry } from '@fusion/locale/countries'
import { getCountryFromLocale } from '@fusion/locale/parsing'

const canteenMenuUserLocationDataFragment = graphql(`
  fragment CanteenAccountLocation_UserDataFragment on User {
    accountLocation {
      address {
        country
      }
    }
  }
`)

export const useDefaultCurrency = (
  userData?: FragmentType<typeof canteenMenuUserLocationDataFragment>,
) => {
  const locale = useLocale()
  const userLocationData = useFragment(canteenMenuUserLocationDataFragment, userData)

  const countryCode =
    userLocationData?.accountLocation?.address.country?.toLowerCase() ||
    getCountryFromLocale(locale || 'en-gb')
  const currencyForLocaleCountry = getCurrencyCodeForCountry(localeCountries, countryCode) ?? ''

  return currencyForLocaleCountry
}
